let blogSwiper;

function initBlogSwiper() {
  const isDesktop = window.innerWidth > 768;
  if (blogSwiper) blogSwiper.destroy(true, true);

  blogSwiper = new Swiper(".wj-blog-hero-card-carousel__blog-swiper", {
    effect: isDesktop ? "cards" : "slide",
    grabCursor: true,
    centeredSlides: true,
    autoHeight: true,
    slidesPerView: 1,
    spaceBetween: isDesktop ? 0 : 20,
    navigation: {
      nextEl: ".wj-blog-hero-card-carousel__container .swiper-button-next",
      prevEl: ".wj-blog-hero-card-carousel__container .swiper-button-prev",
    },
    pagination: {
      el: ".wj-blog-hero-card-carousel__container .swiper-pagination-progress",
      clickable: true,
      renderBullet: function (index, className) {
        return `<span class="${className}"><span class="progress-fill"></span></span>`;
      },
    },
    cardsEffect: {
      rotate: true,
      perSlideRotate: 1,
      perSlideOffset: 1,
      slideShadows: false,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    on: {
      autoplayTimeLeft(swiper, time, progress) {
        // Get previously active index
        const previousIndex = swiper.previousIndex;
        const previousBullet = swiper.pagination.bullets[previousIndex];
        if (previousBullet) {
          const fill = previousBullet.querySelector(".progress-fill");
          if (fill) fill.style.width = "0%";
        }

        // Animate current active bullet
        const activeBullet = swiper.pagination.bullets[swiper.realIndex];
        if (activeBullet) {
          const fill = activeBullet.querySelector(".progress-fill");
          if (fill) {
            fill.style.width = `${(1 - progress) * 100}%`;
          }
        }
      },
      setTranslate(swiper) {
        // Fix unwanted Z-depth shrinking on cards
        swiper.slides.forEach((slide) => {
          slide.style.transform = slide.style.transform.replace(
            /translate3d\(([^,]+),\s*([^,]+),\s*[^)]+\)/,
            "translate3d($1, $2, 0px)"
          );
        });
      },
    },
  });
}

document.addEventListener("DOMContentLoaded", initBlogSwiper);

let resizeTimeout;
window.addEventListener("resize", function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(initBlogSwiper, 300);
});
